import React, { useEffect, useState } from 'react';
import DocHub from 'components/DocHub';
import { Box } from '@mui/material';
import { SectionTitle } from 'components/shared/Typography';

const DocHubSub = ({ vendor, clientVendor }) => {
  const [vendorFilter, setVendorFilter] = useState('');

  // Set vendor filter when component mounts or vendor changes
  useEffect(() => {
    if (clientVendor?.id) {
      // Set the vendor filter to the current vendor's ID
      setVendorFilter(clientVendor.id);
    }
  }, [clientVendor?.id]);


  return (
    <Box sx={{ width: '100%' }}>
      <SectionTitle sx={{ mb: 2 }}>
        Documents Hub - {vendor?.name || 'Vendor'}
      </SectionTitle>
      
      {/* Render the main DocHub component with vendor filter pre-applied */}
      <DocHub 
        vendorFilterId={vendorFilter}
        hideVendorColumn={true}
        embedded={true}
        style={{ width: '100%' }}
      />
    </Box>
  );
};

export default DocHubSub;